import { useCallback } from 'react';
import { isAuthenticated } from '../../utils/helpers';
import eventBus from '../../utils/eventBus';

export const useRequireAuthGuard = () => {
    const guard = useCallback((event, options) => {
        if (isAuthenticated()) {
            return { allowed: true };
        }

        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
        if (event && typeof event.stopPropagation === 'function') {
            event.stopPropagation();
        }

        const popupPayload = {
            type: options?.type || options?.pageTitle || 'login'
        };
        eventBus.emit('auth:require', popupPayload);
        return { allowed: false };
    }, []);

    return guard;
};

const RequireAuthClick = ({ children, onClick, popupType, popupPageTitle }) => {
    const requireAuth = useRequireAuthGuard();

    const handleClick = useCallback(
        event => {
            const result = requireAuth(event, {
                type: popupType,
                pageTitle: popupPageTitle
            });
            if (result.allowed) {
                const childOnClick = children?.props?.onClick;
                const childOfChildOnClick =
                    children?.props?.children?.props?.onClick;
                const targetOnClick =
                    childOnClick || childOfChildOnClick || onClick;
                if (typeof targetOnClick === 'function') {
                    targetOnClick(event);
                }
            }
        },
        [
            requireAuth,
            onClick,
            popupType,
            popupPageTitle,
            children?.props?.onClick,
            children?.props?.children?.props?.onClick
        ]
    );

    // Clone child to inject onClick without altering layout
    if (!children) return null;

    const child = Array.isArray(children) ? children[0] : children;

    return { ...child, props: { ...child.props, onClick: handleClick } };
};

export default RequireAuthClick;
